import {NgModule} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {UIRouterModule} from '@uirouter/angular';
import {dynamicStateConfigFn, Ng2DynamicStateDeclaration} from '@ngx-ivengi/locale';
import {FileComponent} from './file.component';

export let CHILD_STATES: Ng2DynamicStateDeclaration[] = [
  {
    name: 'file',
    component: FileComponent,
    future: true,
    data: {
      pageTitle: 'states.dashboard.pageTitle',
      breadcrumbTitle: 'states.dashboard.breadcrumbTitle'
    }
  }
];

@NgModule({
  imports: [
    UIRouterModule.forChild({
      states: CHILD_STATES,
      config: dynamicStateConfigFn
    }),
    TranslateModule
  ],
  exports: [UIRouterModule]
})
export class FileRoutingModule {}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/file/file.routes.ts